import { useState } from 'react';
import { CaspioConfigForm } from './caspio-config-form';
import {
  hasCustomCredentials,
  isCaspioConfigComplete,
  parseCaspioConfig,
  withCredentialVisibility,
} from './caspio-config';
import { crmTypeLabels } from './crm-config';
import { CrmIntegrationCard } from './crm-integration-card';
import { useCrmIntegrationActions } from './crm-integration-actions';

export function CaspioCrmPanel({
  organizationId,
  integration,
}: {
  organizationId: string;
  integration: { id: string; name: string; config: unknown };
}) {
  const initialConfig = parseCaspioConfig(integration.config);

  const [name, setName] = useState(integration.name);
  const [config, setConfig] = useState(initialConfig);
  const [showCredentials, setShowCredentials] = useState(hasCustomCredentials(initialConfig));
  const { error, isSaving, isRemoving, save, remove } = useCrmIntegrationActions(organizationId, integration.id);

  return (
    <CrmIntegrationCard
      typeLabel={crmTypeLabels.caspio}
      name={name}
      onNameChange={setName}
      error={error}
      isSaving={isSaving}
      isRemoving={isRemoving}
      canSave={isCaspioConfigComplete(config)}
      onSave={() => void save(name, withCredentialVisibility(config, showCredentials))}
      onRemove={() => void remove()}
    >
      <CaspioConfigForm
        config={config}
        onConfigChange={setConfig}
        showCredentials={showCredentials}
        onShowCredentialsChange={setShowCredentials}
        integrationId={integration.id}
      />
    </CrmIntegrationCard>
  );
}
